import React from "react";
import { IWellnessPlanByUser } from "../../../services/wellness-plans-by-user/wellness-plan-by-user.interface";
import { AvatarCustom } from "../../../components";
import { fromUnixToFormattedVisitdateStr } from "../../../utils/unix-timestamp";
import CardProviderDetails from "../../../components/CardProviderDetails/CardProviderDetails";

interface IAssignPaymentPetCard{
    petWellnessDetails: IWellnessPlanByUser
    className?: string
    onClick?:(petId: string)=>void
    isDisabled?: boolean
}

const AssignPaymentPetCard = ({ petWellnessDetails, className, onClick, isDisabled }: IAssignPaymentPetCard) => {
  const handleCardClick=()=>{
    if (isDisabled) return;
    onClick && onClick(petWellnessDetails.wellnessPlanDetails.wellnessId.toString());
  };

  return (
    <div
      className={`flex ${isDisabled ? "cursor-not-allowed" : "cursor-pointer"} ${className || ""}`}
      onClick={handleCardClick}
    >
      <div className="flex items-center">
        <AvatarCustom
          sx={{ margin: "0.5rem" }}
          image={petWellnessDetails.pet.image || undefined }
          name={petWellnessDetails.pet.name}
          width={80}
          height={80}
          wellnessIconHeight={26}
          wellnessIconWidth={26}
          isWellnessMember={petWellnessDetails.pet.isWellnessplan}
        />
      </div>
      <div className="flex flex-col gap-1">
        <div className="flex flex-col gap-[0.1rem]">
          <div className="text-sm text-violet-1">{petWellnessDetails.pet.name}</div>
          <div className="text-lg font-semibold">{petWellnessDetails.planName}</div>
        </div>
        <div className="text-sm text-gray-1 flex gap-1">
          <div>{`$${petWellnessDetails.wellnessPlan.price}/mo`}</div>
          <div className="">·</div>
          <div>{`Renews ${fromUnixToFormattedVisitdateStr(+petWellnessDetails.wellnessPlanDetails.nextRenewal)}`}</div>
        </div>
        <div>
          {petWellnessDetails.isScratchpay ? (
            <div className="text-sm text-gray-1">
              Payment managed through ScratchPay.
            </div>
          ) : (petWellnessDetails.wellnessPlanDetails?.cardDetails?.cardBrand &&
          petWellnessDetails.wellnessPlanDetails?.cardDetails?.last4) ?<CardProviderDetails
              cardBrand={petWellnessDetails.wellnessPlanDetails.cardDetails.cardBrand}
              lastFourDigits={petWellnessDetails.wellnessPlanDetails.cardDetails.last4}
            />:
            <div className="text-sm text-gray-1">
            Card details not available.
            </div>
          }
        </div>
      </div>
    </div>
  );
};

export default AssignPaymentPetCard;
